import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,Select } from 'antd'

import { Page,Crud } from '../../components'
const Option = Select.Option;

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class SystemConfigTypePage extends Component {
  static propTypes = {
    systemconfig: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { systemConfigTypePage,currentSystemConfigType} = this.props.systemconfig;
     this.fetchList( systemConfigTypePage);
  }

  fetchList = (page,values) => {
    const {getSystemConfigTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getSystemConfigTypeList(params);
  }

  getDataSource() {
    const { systemconfig } = this.props;
    const { systemConfigTypeById, systemConfigTypeList } = systemconfig;
    if (!systemConfigTypeList) return [];
    return systemConfigTypeList.map(id => systemConfigTypeById[id]);
  }

  get listProps() {
    const { systemconfig,actions } = this.props
    const { getSystemConfigTypeListPending,systemConfigTypeTotal,systemConfigTypePage } = systemconfig
    const { deleteSystemConfigType,chooseCurrentSystemConfigType,systemConfigTypeModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getSystemConfigTypeListPending,
      columns:[
        {
          title: "类别名",
          dataIndex: 'typeName',
          key: 'typeName',
          width: 180,
        },
        {
          title: "类别tag",
          dataIndex: 'typeTag',
          key: 'typeTag',
          width: 180,
        },
        {
          title: "数据类型",
          dataIndex: 'dataType',
          key: 'dataType',
          width: 180,
          render:(text) => {
              if (text == 1){
                return <div>树</div>
              }else{
                return <div>列表</div>
              }
          }
        },
      ],
      pagination:{
        total:systemConfigTypeTotal,
        current:systemConfigTypePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentSystemConfigType(record);
          systemConfigTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteSystemConfigType(record.id).then((data) => {
            this.fetchList(systemConfigTypePage);
          })
        }
      }
    }
  } 

  getType = () => {
      const dicList = [{
          id:1,
          title:"树"
      },
      {
            id:2,
            title:"列表"
        }
    ]
    return dicList.map(item => (
          <Option key={item.id}>{item.title}</Option>
    ))
}

  get modalProps() {
    const { systemconfig,actions } = this.props
    const { currentSystemConfigType, systemConfigTypeModalVisible,systemConfigTypePage, systemConfigTypeModalType,submitSystemConfigTypePending } = systemconfig

    const { systemConfigTypeModalChange,submitSystemConfigType } = actions;
    const editItem  = systemConfigTypeModalType === 'create' ? {} : currentSystemConfigType
    return {
      item: systemConfigTypeModalType === 'create' ? {} : currentSystemConfigType,
      visible: systemConfigTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitSystemConfigTypePending,
      title: `${
        systemConfigTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "typeName",
          label: "类别名",
          initialValue: editItem.typeName,
          widget: Input,
          required: true
        },
        {
          key: "typeTag",
          label: "类别tag",
          initialValue: editItem.typeTag,
          widget: Input,
          required: true
        },
        {
          key: "dataType",
          label: "数据类别",
          initialValue: "" + editItem.dataType,
          widget: Select,
          children:this.getType(),
          required: true
        },
        
      ],
      onOk: data => {
        submitSystemConfigType(Object.assign({},data,{})).then(data=> {
          systemConfigTypeModalChange(false,"create");
          this.fetchList(systemConfigTypePage);
        })
      },
      onCancel() {
        systemConfigTypeModalChange(false,"create");
      },
    }
  }

  get buttonProps() {
    const { actions,systemconfig } = this.props
    const { currentSystemConfigType,systemConfigTypePage} = systemconfig
    const { systemConfigTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ systemConfigTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    systemconfig: state.systemconfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SystemConfigTypePage);


// WEBPACK FOOTER //
// ./src/features/systemconfig/SystemConfigTypePage.js